module.exports = __webpack_public_path__ + "img/22.766e1ec8.jpg";